import { useTranslation } from "react-i18next"
import { MyTableComponent } from "components"
import { Box } from "theme-ui"
import redselect from "./redselect.png"
import selecticon from "./selecticon.png"
import slidersign from "./slidersign.png"

export const TimeDifferenceSystem = () => {
 // language translator
 const { t } = useTranslation("translation")
 const data = [
  {
   infoone: redselect,
   infotwo: "Forum Gera",
   infothree: "XXX XXX Engersche StraBe / Johannisbach",
   infofour: "27.02.2023 15:09:52",
   infofive: "27.02.2023 15:09:52",
   infosix: "1115921",
   infoseven: "Liste initialisieren Liste 35 Version 120 vom 12.09.2022 11:23:08 schreiben",
  },
  {
   infoone: redselect,
   infotwo: "Forum Gera",
   infothree: "XXX XXX Engersche StraBe / Johannisbach",
   infofour: "27.02.2023 15:09:52",
   infofive: "27.02.2023 15:09:52",
   infosix: "1115921",
   infoseven: "Liste initialisieren Liste 35 Version 120 vom 12.09.2022 11:23:08 schreiben",
  },
  {
   infoone: redselect,
   infotwo: "Forum Gera",
   infothree: "XXX XXX Engersche StraBe / Johannisbach",
   infofour: "27.02.2023 15:09:52",
   infofive: "27.02.2023 15:09:52",
   infosix: "1115921",
   infoseven: "Liste initialisieren Liste 35 Version 120 vom 12.09.2022 11:23:08 schreiben",
  },
  {
   infoone: redselect,
   infotwo: "Forum Gera",
   infothree: "XXX XXX Engersche StraBe / Johannisbach",
   infofour: "27.02.2023 15:09:52",
   infofive: "27.02.2023 15:09:52",
   infosix: "1115921",
   infoseven: "Liste initialisieren Liste 35 Version 120 vom 12.09.2022 11:23:08 schreiben",
  },
  {
   infoone: redselect,
   infotwo: "Forum Gera",
   infothree: "XXX XXX Engersche StraBe / Johannisbach",
   infofour: "27.02.2023 15:09:52",
   infofive: "27.02.2023 15:09:52",
   infosix: "1115921",
   infoseven: "Liste initialisieren Liste 35 Version 120 vom 12.09.2022 11:23:08 schreiben",
  },
  {
   infoone: redselect,
   infotwo: "Forum Gera",
   infothree: "XXX XXX Engersche StraBe / Johannisbach",
   infofour: "27.02.2023 15:09:52",
   infofive: "27.02.2023 15:09:52",
   infosix: "1115921",
   infoseven: "Liste initialisieren Liste 35 Version 120 vom 12.09.2022 11:23:08 schreiben",
  },
  {
   infoone: redselect,
   infotwo: "Forum Gera",
   infothree: "XXX XXX Engersche StraBe / Johannisbach",
   infofour: "27.02.2023 15:09:52",
   infofive: "27.02.2023 15:09:52",
   infosix: "1115921",
   infoseven: "Liste initialisieren Liste 35 Version 120 vom 12.09.2022 11:23:08 schreiben",
  },
  {
   infoone: redselect,
   infotwo: "Forum Gera",
   infothree: "XXX XXX Engersche StraBe / Johannisbach",
   infofour: "27.02.2023 15:09:52",
   infofive: "27.02.2023 15:09:52",
   infosix: "1115921",
   infoseven: "Liste initialisieren Liste 35 Version 120 vom 12.09.2022 11:23:08 schreiben",
  },
  {
   infoone: redselect,
   infotwo: "Forum Gera",
   infothree: "XXX XXX Engersche StraBe / Johannisbach",
   infofour: "27.02.2023 15:09:52",
   infofive: "27.02.2023 15:09:52",
   infosix: "1115921",
   infoseven: "Liste initialisieren Liste 35 Version 120 vom 12.09.2022 11:23:08 schreiben",
  },
  {
   infoone: redselect,
   infotwo: "Forum Gera",
   infothree: "XXX XXX Engersche StraBe / Johannisbach",
   infofour: "27.02.2023 15:09:52",
   infofive: "27.02.2023 15:09:52",
   infosix: "1115921",
   infoseven: "Liste initialisieren Liste 35 Version 120 vom 12.09.2022 11:23:08 schreiben",
  },
 ]

 const columns = [
  {
   Header: () => (
    <div className="pl-2">
     <img src={data[0].infoone} alt="selecticon" />
    </div>
   ),
   accessor: "infoone",
   Cell: ({ row }: any) => (
    <div className="w-full">
     <img className="w-full" src={row.original.infoone} alt="selecticontwo" />
    </div>
   ),
  },
  { Header: t("headquarters"), accessor: "infotwo" },
  { Header: t("Device"), accessor: "infothree" },
  { Header: t("attachmentsPointInTime"), accessor: "infofour" },
  { Header: t("entryTime"), accessor: "infofive" },
  { Header: t("difference"), accessor: "infosix" },
  { Header: t("Task"), accessor: "infoseven" },
 ]

 return (
  <div className="relative h-screen  md:h-screen lg:h-full w-[96%] mx-auto">
   <div className="flex justify-between mx-2 py-4 ">
    <h1 className="font-semibold text-2xl Jakarta-font">{t("timeDifferences")}</h1>
    <div className="bg-white h-10 w-10 rounded flex justify-center items-center">
     <img src={slidersign} alt="slidersignimg" />
    </div>
   </div>
   <Box bg="highlight" className="py-2 px-2">
    <Box bg="light_gray" className="flex justify-between  py-4 rounded mx-2 px-3 ">
     <div className="flex items-center">
      <div>
       <img className="rotate-[90deg]" src={selecticon} alt="selecticon" />
      </div>
      <h1 className="font-semibold font-sm Jakarta-font">1000 {t("events")}</h1>
     </div>

     <div className="custom-checkbox">
      <input type="checkbox" id="updata" />
      <label className="font-semibold font-sm Jakarta-font" htmlFor="updata">
       {t("updateAutomatically")}
      </label>
     </div>
    </Box>
   </Box>

   {/* ====== TableComponent ====== */}
   <MyTableComponent fullHeight={false} columns={columns} data={data} paginate={true} />
  </div>
 )
}
